import React, { Component } from 'react';
import { Button, Icon, Modal, Grid } from 'semantic-ui-react';
import 'react-html5-camera-photo/build/css/index.css';
import { isTabletOrLess } from 'utils/isMobile';
import debounce from 'lodash.debounce';

const styles = {
	borderedCard: {
		display: 'flex',
		flex: 1,
		height: window.innerHeight * 0.5,
		border: '1px solid grey',
		justifyContent: 'center',
		alignItems: 'center',
		fontSize: 32,
	},
	scanInput: {
		background: 'transparent',
		borderStyle: 'solid',
		borderColor: 'white',
		borderRadius: 5,
		color: 'white',
		fontSize: 20,
		outline: 0,
	},
	subtitle: {
		display: 'block',
		fontSize: 20,
	},
	centered: {
		display: 'flex',
		justifyContent: 'center',
	},
};
class QRReaderPrescriptionModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			alternativeScannerValue: '',
			scanInputValue: '',
		};
	}

	getScan = (values) => {
		this.props.close();
		this.props.submit(values.barcodes[0].data);
	};

	getScanAlternativeScanner = (value) => {
		this.props.close();
		this.props.submit(value);
	};

	submitAlternativeScanner = debounce(this.getScanAlternativeScanner, 700);

	handleKeyDown = (event) => {
		const { scanInputValue } = this.state;
		if (event.key === 'Enter' && scanInputValue !== '')
			this.submitAlternativeScanner(scanInputValue);
	};

	render() {
		const { open} = this.props;
		const { scanInputValue } = this.state;

		return (
			<div>
				<Modal
					basic
					size={isTabletOrLess ? 'small' : 'large'}
					open={open}
					closeOnEscape={true}
					closeOnDimmerClick={true}
					onClose={this.props.close}
				>
					

					
						<div style={styles.borderedCard}>
							<Grid columns={1}>
								<Grid.Row>
									<Grid.Column style={styles.centered}>
										Scanner votre code...
									</Grid.Column>
								</Grid.Row>
								<Grid.Row>
									<Grid.Column
										style={{ ...styles.subtitle, ...styles.centered }}
									>
										Puis faites "Entrée" ou cliquer sur le bouton valider
									</Grid.Column>
								</Grid.Row>
								<Grid.Row>
									<Grid.Column style={styles.centered}>
										<input
											style={styles.scanInput}
											autoFocus
											autoComplete='off'
											type='text'
											name='scanned-value'
											onChange={(e) => {
												this.setState({
													scanInputValue: e.target.value,
												});
											}}
											onKeyDown={this.handleKeyDown}
										/>
									</Grid.Column>
								</Grid.Row>
							</Grid>
						</div>
					

					<Modal.Actions>
					
							<Button
								basic
								color='green'
								onClick={() => this.submitAlternativeScanner(scanInputValue)}
								inverted
								disabled={scanInputValue === ''}
							>
								<Icon name='checkmark' /> Valider
							</Button>
					
						<Button
							basic
							color='red'
							onClick={(e) => {
								if (e !== undefined) e.preventDefault();
								this.props.close();
							}}
							inverted
						>
							<Icon name='remove' /> Annuler
						</Button>
					</Modal.Actions>
				</Modal>
			</div>
		);
	}
}


export default (QRReaderPrescriptionModal);
